import {i18n, DEFAULT_LANGUAGE} from '../../languages';
import moment from 'moment';

const namespace = 'locale/';
// Store mutations/actions/getters
export const GET_LANGUAGE = namespace + 'get_language';
export const SET_LANGUAGE = namespace + 'set_language';
export const LANGUAGE_CODES = namespace + 'languages';
// Other constants
const STORAGE_KEY = 'lang';

export default {
    state: {
        languages: ['nl', 'fr'],
        active: (i18n.locale = localStorage.getItem(STORAGE_KEY) || DEFAULT_LANGUAGE),
    },
    mutations: {
        [SET_LANGUAGE]: (state, code) => {
            console.assert(state.languages.includes(code));
            state.active = code;
            // Apply to document/runtime
            i18n.locale = code;
            moment.locale(code);
            localStorage.setItem(STORAGE_KEY, code);
            document.querySelector('html').setAttribute('lang', code);
        },
    },
    actions: {
        [SET_LANGUAGE]: ({commit}, code)=>{
            commit(SET_LANGUAGE, code);
            // Here is an oppertunity to update the account language settings
            return Promise.resolve();
        },
    },
    getters: {
        [GET_LANGUAGE]: (state) => state.active,
        [LANGUAGE_CODES]: (state) => state.languages,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/locale.js